var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('article',[_c('h1',[_vm._v("We’ll be back soon!")]),_c('div',[_c('p',[_vm._v(" Sorry for the inconvenience but we’re performing some maintenance at the moment. We’ll be back online shortly! ")])])])])
}]

export { render, staticRenderFns }